import PaSelect from "../../../components/field/PaSelect";
import { MetaInformation } from "../Process";

interface Props {
  stepIndex: number;
  meta?: MetaInformation;
}

const GENERATE_DOC_ACCEPTABLE_FILE_TYPES = ["doc", "docx"];

export default function GenerateDocumentDefinition(props: Props) {
  const { stepIndex, meta } = props;

  return (
    <PaSelect
      name={`steps.${stepIndex}.stepInformation.generateDocumentContent.fileId`}
      label="Dokumento šablonas"
      tooltip="Pasirinkite DOCX šabloną, iš kurio bus sugeneruotas dokumentas."
      options={
        meta?.files
          ?.filter((file) => {
            const extension = file?.name?.split(".")?.at(-1)?.toLowerCase();
            return extension && GENERATE_DOC_ACCEPTABLE_FILE_TYPES.includes(extension);
          })
          ?.map((file) => ({
            value: file?.id,
            label: file?.name,
          })) ?? []
      }
    />
  );
}
